import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// import { AsyncPipe } from '@angular/common';
// PIPES
import { FileTypePipe } from '@pipes/file-type-icon.pipe';
import { ResourceTypePipe } from '@pipes/resource-type-icon.pipe';
import { SafePipe } from '@pipes/safe.pipe';
import { JoinPlainPipe } from '@pipes/join-plain.pipe';
// COMPONENTS
import { UIContentEmpty } from './components/content-empty/content-empty';
import { UIContentMain } from '@shared/components/content-main/content-main';
import { UIHeader } from '@shared/components/header/header';
import { UIContentMainHeader } from '@shared/components/content-main-header/content-main-header';
import { UIMain } from '@shared/components/main/main';
import { UIMenu } from '@shared/components/menu/menu';
import { UIMultimediaDialog } from '@shared/components/multimedia-dialog/multimedia-dialog';
import { UISidebar } from '@shared/components/sidebar/sidebar';
import { UISidebarFilter } from '@shared/components/sidebar-filter/sidebar-filter';
import { UISuccessDialogComponent } from './components/success-dialog/success-dialog.component';
import { UIConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MultimediaDialogComponent } from './components/container-document-dialog/multimedia-dialog.component';
import { MultimediaComponent } from './components/multimedia/multimedia.component';
// QUESTION AND ANSWERS
import { ReagentBase } from './components/reagent/reagent/reagent-base';
import { ReagentFormBase } from './components/reagent/reagent-form-base/reagent-form-base';
import { ReagentTableBase } from './components/reagent/reagent-table-base/reagent-table-base';
import { ImageMultipleAnswerComponent } from './components/answer/image-multiple-answer/image-multiple-answer.component';
import { MultipleAnswerComponent } from './components/answer/multiple-answer/multiple-answer.component';
import { OpenAnswerComponent } from './components/answer/open-answer/open-answer.component';
import { RelationalAnswerComponent } from './components/answer/relational-answer/relational-answer.component';
import { TrueFalseAnswerComponent } from './components/answer/true-false-answer/true-false-answer.component';
// DIRECTIVES
import { AutoFocusDirective } from '@directives/auto-focus.directive';
import { ClickFocusRemoveDirective } from '@directives/click-focus-remove.directive';
import { NumberDirective } from '@directives/number.directive';
import { NumberIntegerDirective } from '@directives/number-integer.directive';
import { FilterNodeBase } from '@directives/filter-node-base';
// MODULES
import { MaterialModule } from './modules/material.module';
import { NativeModule } from './modules/native/module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { AngularEditorModule } from '@kolkov/angular-editor';

import {
	RecaptchaModule,
	RecaptchaFormsModule,
	RECAPTCHA_SETTINGS,
	RecaptchaSettings,
} from 'ng-recaptcha';
import { TreeviewModule } from './modules/ngx-select/treeview.module';
import { FilterNodeBasePl } from '@directives/filter-node-base_pl';

const MODULES_ANGULAR = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule];

const MODULES = [
	MaterialModule,
	NativeModule,
	NgxSpinnerModule,
	PdfJsViewerModule,
	RecaptchaModule,
	RecaptchaFormsModule,
	AngularEditorModule,
	TreeviewModule.forRoot(),
];

const COMPONENTS: any[] = [
	UIContentEmpty,
	UIContentMain,
	UIContentMainHeader,
	UIHeader,
	UIMain,
	UIMenu,
	UIMultimediaDialog,
	UISidebar,
	UISidebarFilter,
	UISuccessDialogComponent,
	UIConfirmDialogComponent,
	MultimediaDialogComponent,
	MultimediaComponent,
	// QUESTION AND ANSWERS
	ImageMultipleAnswerComponent,
	MultipleAnswerComponent,
	OpenAnswerComponent,
	RelationalAnswerComponent,
	TrueFalseAnswerComponent,
];

const PIPES: any[] = [
	FileTypePipe,
	ResourceTypePipe,
	JoinPlainPipe,
	SafePipe,
	// JoinPlainPipe
];

const DIRECTIVES: any[] = [
	AutoFocusDirective,
	ClickFocusRemoveDirective,
	NumberDirective,
	NumberIntegerDirective,
	FilterNodeBase,
	ReagentBase,
	ReagentTableBase,
	ReagentFormBase,
	FilterNodeBasePl,
];

@NgModule({
	declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES],
	imports: [...MODULES_ANGULAR, ...MODULES],
	exports: [...MODULES, ...MODULES_ANGULAR, ...COMPONENTS, ...PIPES, ...DIRECTIVES],
	providers: [
		{
			provide: RECAPTCHA_SETTINGS,
			useValue: {
				siteKey: '6Lfj0cIZAAAAAOJmv6tTMl-cbXtQr5Hrm3pxTRtO',
			} as RecaptchaSettings,
		},
		/* AsyncPipe */
	],
})
export class SharedModule {}
